import { makePermissionCheckResultFailure } from '@atlassian/mpac-spi';
import { Either, Option } from 'funfix-core';
import { Record } from 'immutable';
import { makeInstallableApp } from '../InstallableApp';
import { makeInstallableAppByKeyIdentifier } from '../InstallableAppIdentifier';
import { makePendingConfirmationInstallStatus } from './InstallStatus';
export const INSTALLABLE_APP_DEFAULT_INSTALL_MODE = 'INSTALLABLE_APP_DEFAULT';
export const makeInstallableAppDefaultInstallMode = Record({
  type: INSTALLABLE_APP_DEFAULT_INSTALL_MODE,
  installableApp: makeInstallableApp(),
  installableAppId: makeInstallableAppByKeyIdentifier(),
  installPermission: Either.left(makePermissionCheckResultFailure()),
  installedApp: Option.empty(),
  relayState: undefined,
  status: makePendingConfirmationInstallStatus()
});